class Type {
	public static YES = new Type(true, "Yes");
	public static NO = new Type(false, "No");

	private constructor(
					public readonly value: boolean,
					public readonly label: string,
	) {}

	public get yes() {
					return this === Type.YES;
	}

	public get no() {
					return this === Type.NO;
	}

	public static values(): Type[] {
					return [Type.YES, Type.NO];
	}

	public static getByValue(value: boolean) {
					return this.values().find(type => type.value === value);
	}

	public static getByLabel(label: string) {
					return this.values().find(type => type.label.toLowerCase() === label.toLowerCase());
	}
}

export { Type as YesNoType };